import { Record, List } from 'immutable';
import isEmpty from 'transmute/isEmpty';
import filter from 'transmute/filter';
import pipe from 'transmute/pipe';
import map from 'transmute/map';
import TranslatedLogEventMessage, { TranslatedLogEventMessageKeys } from './TranslatedLogEventMessage';
import { TranslatedLogEventMessageFieldDefinitionKeys } from './TranslatedLogEventMessageFieldDefinition';
export const TranslatedLogEventMessageConfigKeys = {
  FIELD_DEFINITIONS: 'fieldDefinitions'
};
const defaultProps = {
  [TranslatedLogEventMessageConfigKeys.FIELD_DEFINITIONS]: List()
};
export default class TranslatedLogEventMessageConfig extends Record(defaultProps, 'TranslatedLogEventMessageConfig') {
  populate(...fieldDefinitions) {
    return this.set(TranslatedLogEventMessageConfigKeys.FIELD_DEFINITIONS, List(fieldDefinitions));
  }
  getVisibleLogEventMessages(logEvent, objectTypeId) {
    const processDefinitions = pipe(map(definition => {
      const definitionConstructor = definition[TranslatedLogEventMessageFieldDefinitionKeys.MESSAGE_RESOLVER];
      return new TranslatedLogEventMessage({
        [TranslatedLogEventMessageKeys.FIELD_KEY]: definition[TranslatedLogEventMessageFieldDefinitionKeys.FIELD_KEY],
        [TranslatedLogEventMessageKeys.MESSAGE]: definitionConstructor && definitionConstructor(logEvent, objectTypeId),
        [TranslatedLogEventMessageKeys.IS_PRIMARY_RISK_MESSAGE]: definition[TranslatedLogEventMessageFieldDefinitionKeys.IS_PRIMARY_RISK_MESSAGE_FIELD],
        [TranslatedLogEventMessageKeys.IS_SECONDARY_RISK_MESSAGE]: definition[TranslatedLogEventMessageFieldDefinitionKeys.IS_SECONDARY_RISK_MESSAGE_FIELD]
      });
    }), filter(message => !isEmpty(message[TranslatedLogEventMessageKeys.MESSAGE])));
    return processDefinitions(this[TranslatedLogEventMessageConfigKeys.FIELD_DEFINITIONS]);
  }
}